import React from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Card as MuiCard, CardContent, Divider, LinearProgress, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { spacing } from '@mui/system'
import { useTranslation } from 'react-i18next'
import useAuth from '../../../hooks/useAuth'
import InvestorApi from '../../../api/InvestorApi'
import InvestorsGrid from './InvestorsGrid'
import { InvestorListItem, USER_EVENT_TYPES } from '@finance-lab/utils/types'
import { useLogUserEvent } from '../../../hooks/useLogUserEvent'

const Card = styled(MuiCard)(spacing)

function InvestorsView() {
    const { t } = useTranslation()
    const { isAuthenticated } = useAuth()

    const [investors, setInvestors] = React.useState<Array<InvestorListItem> | null>(null)

    useLogUserEvent(USER_EVENT_TYPES.SHOW_ALL_INVESTORS)

    React.useEffect(() => {
        async function fetchInvestors() {
            if (!isAuthenticated) return
            const api = new InvestorApi()
            const response = await api.allInvestors()
            setInvestors(response)
        }
        void fetchInvestors()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Helmet title={t('entities.investor.plural')} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                {t('entities.investor.plural')}
            </Typography>
            <Divider />
            <Card mb={6}>
                <CardContent>
                    {!investors && <LinearProgress />}
                    {investors && <InvestorsGrid investors={investors} setInvestors={setInvestors} />}
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default InvestorsView
